/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftEnd200, PostApiBarberShiftEnd400, PostApiBarberShiftEnd401, PostApiBarberShiftEnd403, PostApiBarberShiftEnd404, PostApiBarberShiftEnd500, PostApiBarberShiftEndMutationResponse } from "../entities/PostApiBarberShiftEnd";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftEnd200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberShiftEnd200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftEnd400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftEnd400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftEnd401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftEnd401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftEnd403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftEnd403>

/**
 * @description Not Found
 */
export const postApiBarberShiftEnd404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftEnd404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftEnd500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftEnd500>

export const postApiBarberShiftEndMutationResponseSchema = z.lazy(() => postApiBarberShiftEnd200Schema) as unknown as z.ZodType<PostApiBarberShiftEndMutationResponse>